export const transactionTheme = {
  chargebackStatistics: {
    fieldName: 'palette.tertiary.80',
    fieldValue: 'palette.primary.99',
  },
  detailsBlock: {
    approveIcon: 'palette.success.40',
    borderColor: 'palette.surface.4',
    borderWidth: '1px',
    declineIcon: 'palette.error.40',
    refundModal: {
      fieldName: 'palette.tertiary.80',
      fieldValue: 'palette.primary.99',
    },
  },
  divider: {
    bg: 'palette.surface.4',
    height: '1px',
    verticalGap: '16px',
  },
  operationHistory: {
    extraDetailsModal: {
      bg: 'palette.surface.4',
      bgEven: 'palette.surface.3',
      iconsColor: 'palette.tertiary.30',
      text: 'palette.tertiary.80',
    },
  },
};
